<template>
  <v-layout justify-center>
    <v-dialog v-model="dialog_status" scrollable max-width="400px"
      @keydown.esc="close()">
      <v-card>
        <v-card-title id="card-title-wrapper">
          <span>도큐먼트 클립</span>
          <v-btn icon @click="close()"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>

        <v-card-text>
          <span class="word-break">언제 어디서나 관심있는 자료를 발견하면 도큐먼트 클립을 이용해보세요.</span>
          <span class="word-break">클립에 모아둔 자료는 언제나 회원님의 프로젝트에 추가할 수 있습니다.</span>
        </v-card-text>
        
        <v-card-text>
          도큐먼트 클립은 <b>프리미엄 회원</b>에게 제공됩니다.
        </v-card-text>

        <v-card-actions>
          <v-btn depressed block dark color="#ff5193"
            :to="{name: 'signup'}">프리미엄 구독하기</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      dialog:'modal/expired_doc_clip_visible',
    }),

    dialog_status: {
      get: function(value) {
        return this.dialog
      },
      set: function(value) {
        if (!value) { this.close() }
      },
    },
  },

  methods: {
    close() {
      this.$store.commit('modal/hideExpiredDocClip')
    },
  },

}
</script>

<style scoped>
  #card-title-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
  }
</style>


// WEBPACK FOOTER //
// src/components/modal/ExpiredDocClip.vue